export default {
  path: '/material_supply_subs',
  name: 'material_supply_subs',
  component: () => import('../components/materialsupplysub/Layout'),
  redirect: { name: 'MaterialSupplySubList' },
  children: [
    /*
    {
      name: 'MaterialSupplySubList',
      path: '',
      component: () => import('../views/materialsupplysub/List')
    },
    {
      name: 'MaterialSupplySubCreate',
      path: 'new',
      component: () => import('../views/materialsupplysub/Create')
    },
    {
      name: 'MaterialSupplySubUpdate',
      path: ':id/edit',
      component: () => import('../views/materialsupplysub/Update')
    },
    {
      name: 'MaterialSupplySubShow',
      path: ':id',
      component: () => import('../views/materialsupplysub/Show')
    }
    */
  ]
};
